"use client";

import { Loading } from "@/components/loading";
import { AlertDialog, AlertDialogContent } from "@/components/ui/alert-dialog";
import { Toaster } from "@/components/ui/sonner";
import { useLoadingStore } from "@/store/loading.store";

export function UIProvider({ children }: { children: React.ReactNode }) {
  const { isLoading } = useLoadingStore();

  return (
    <>
      <AlertDialog open={isLoading}>
        <AlertDialogContent className="border-none bg-transparent shadow-none filter-none">
          <div className="flex flex-col items-center justify-center">
            <Loading className="text-primary" />
          </div>
        </AlertDialogContent>
      </AlertDialog>
      <Toaster />
      {children}
    </>
  );
}
